import React from "react";
import FileUploader from '../file-uploader'

class ContractOverviewDetailedContractInfo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            addPhotoView: false,
        }

        this.toggleAddPhotoView = this.toggleAddPhotoView.bind(this)
    }

    toggleAddPhotoView() {
        this.setState({
            addPhotoView: !this.state.addPhotoView
        })
    }

    render() {
        let contracts = this.props.contracts;

        return (
            <div>        
                <FileUploader contractId={this.props.contract.ContractId} multipleIds={this.props.multipleIds} dispatch={this.props.dispatch} multiple={true} updateContract={true} contracts={this.props.contracts} toggleAddPhotoView={this.toggleAddPhotoView} />
            </div>

        )
    }
}

export default ContractOverviewDetailedContractInfo